
export interface InsightHubConfig {
    startDate: string;
    key: string;
    storageKey: string;
    monthsInterval: number;
    type: string;
}

/**
 * Determines if an insight survey should be shown based on time interval
 * @param lastShownDate ISO string of when the survey was last shown
 * @param startDate Date from which the survey should start being shown
 * @param monthsInterval Number of months between showings
 * @returns Boolean indicating if the survey should be shown
 */
export function shouldShowInsightSurvey(
    lastShownDate: string | null, 
    startDate: string,
    monthsInterval: number
): boolean {
    const now = new Date();
    
    const startDateObj = new Date(startDate);

    // startdate is in the future
    if (startDateObj > now) {
        return false; 
    }
    
    // never shown before
    if (!lastShownDate) {
        return true; 
    }
    
    const lastShown = new Date(lastShownDate);
    const monthsDifference =
        (now.getFullYear() - lastShown.getFullYear()) * 12 +
        (now.getMonth() - lastShown.getMonth());
    
    return monthsDifference >= monthsInterval;
}

/**
 * Get storage key for a specific insight survey type
 * @param type Survey type identifier (e.g., 'nps', 'sus')
 * @returns Full storage key string
 */
export function getInsightStorageKey(type: string): string {
    return `insight-hub-last-shown-${type}`;
}